import { Decorate } from './types';
import { AxiosRequestConfig } from 'axios';
import { BFFServiceAuth } from '@/api/common';
import { webStore } from '@/store/base';

/*
 * Decorate BFFService
 */
export default class BFFService extends Decorate {
  async _addToken(config: AxiosRequestConfig) {
    const apiKey = await BFFServiceAuth.getApiKey();
    const platform = webStore.paramManager.getParam('platform');

    config.headers['Authorization'] = `Bearer ${apiKey}`;
    config.headers['x-platform'] = platform;

    return config;
  }

  async config(config: AxiosRequestConfig) {
    await super.config(config);

    await this._addToken(config);
  }
}
